export default function AdminDriverManagement() {

  return (
      <p>مدیریت حساب رانندگان</p>
  );
};